import JSZip from "jszip";
import { heicTo } from "heic-to"

export interface ConversionResult {
    success: boolean;
    message: string;
    filename?: string;
}
/**
 * Generate separate PDF blobs (one per image) and return an array of { filename, blob }
 */

export const generateSeparateHEIClobs = async (
    files: File[],
    quality: number = 0.92
): Promise<{ filename: string; blob: Blob }[]> => {
    const result: { filename: string; blob: Blob }[] = [];

    for (const file of files) {
        const convertedBlob = await heicTo({
            blob: file,
            type: "image/jpeg",
            quality,
        });

        const blob = Array.isArray(convertedBlob)
            ? convertedBlob[0]
            : convertedBlob;

        const originalName = file.name.replace(/\.[^/.]+$/, "");

        result.push({
            filename: `${originalName}.jpg`,
            blob: blob as Blob,
        });
    }

    return result;
};

export const createZipFromBlobs = async (files: { filename: string; blob: Blob }[]): Promise<Blob> => {
    const zip = new JSZip();
    for (const f of files) {
        zip.file(f.filename, f.blob);
    }
    const content = await zip.generateAsync({ type: "blob" });
    return content;
};

